import { render, staticRenderFns } from "./HeaderDropdownFlags.vue?vue&type=template&id=ba0d501a&class=FlagAlertDropdown&"
import script from "./HeaderDropdownFlags.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownFlags.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdownFlags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports